import { IApprovalModalState } from './types'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { postApprovalPostsThunk } from './thunks'
import { TPostForApproval } from '../../managePost/newTypes'

const initialState: IApprovalModalState = {
  posts_for_approval: [],
  is_approval_modal_open: false
}

const duplicateModaltSlice = createSlice({
  name: 'approvalPost',
  initialState,
  reducers: {
    toggleIsOpenAprrovalModalAction: (state) => {
      state.is_approval_modal_open = !state.is_approval_modal_open
    },
    setPostsForApprovalAction: (state, action: PayloadAction<TPostForApproval[]>) => {
      state.posts_for_approval = action.payload
    },
    setInitialStateAction: (state) => {
      state.is_approval_modal_open = false
      state.posts_for_approval = []
    }
  },
  extraReducers: (builder) => {
    builder.addCase(postApprovalPostsThunk.pending, (state, action) => {})
    builder.addCase(postApprovalPostsThunk.fulfilled, (state, action) => {
      state.is_approval_modal_open = false
      state.posts_for_approval = []
    })
    builder.addCase(postApprovalPostsThunk.rejected, (state, action) => {})
  }
})

export const { setInitialStateAction, toggleIsOpenAprrovalModalAction, setPostsForApprovalAction } =
  duplicateModaltSlice.actions
export default duplicateModaltSlice.reducer
